import RangeSettingsCard from "./RangeSettingsCard";

export default RangeSettingsCard;
